import { useLazyQuery } from '@common/hooks';
import { Input } from 'antd';
import React, { ComponentProps, useEffect } from 'react';
import { ErrorHandler } from '@common/components';
import {
  MembershipByEmail,
  WorksMembershipByEmailQuery,
  WorksMembershipByEmailResponse,
} from 'works/graphql/works-membership-by-email';

export type OnMembershipLoaded = (membership: MembershipByEmail) => void;

type Props = {
  loadOnMount?: boolean;
  onMembershipLoaded?: OnMembershipLoaded;
} & ComponentProps<typeof Input.Search>;

export function WorksMembershipSearchInputByEmail({
  loadOnMount,
  onMembershipLoaded,
  ...props
}: Props) {
  const [findMembership, { loading, error }] =
    useLazyQuery<WorksMembershipByEmailResponse>(WorksMembershipByEmailQuery, {
      onCompleted(data) {
        onMembershipLoaded?.(data.worksMembershipByEmail);
      },
    });

  function handleFindMembership(value?: typeof props.value) {
    // Ignore empty value search, caused by the clear button action.
    if (!value) {
      return;
    }

    return findMembership({
      variables: { email: value, includeWorkers: true },
    });
  }

  useEffect(
    () => {
      if (!loadOnMount) {
        return;
      }

      handleFindMembership(props.value);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="WorksMembershipSearchInputByEmail"
        messageType="contextual"
      />
    );
  }

  return (
    <Input.Search
      size="large"
      placeholder="email"
      onSearch={handleFindMembership}
      loading={loading}
      {...props}
    />
  );
}
